import { render, staticRenderFns } from "./IndividualBrokerView.vue?vue&type=template&id=1a07a38a&"
import script from "./IndividualBrokerView.vue?vue&type=script&lang=js&"
export * from "./IndividualBrokerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports